import React from 'react'
import { createRoot } from 'react-dom/client'
import EditExerciseBlock from '@components/EditExerciseBlock'
import { cloneDeep, isEqual } from 'lodash'

export const connectToEditorjs = (Component, title, icon, onSave) => {
  if (!Component) {
    return null
  }

  return class Block {
    /**
     * Constructor
     * @param {*} blockConfig
     */
    constructor(blockConfig) {
      // Initial data
      this.data = blockConfig.data ? blockConfig.data : {}
      // Pass any config as props to the component
      this.config = blockConfig.config
      this.onChange = blockConfig.config.onChange
      this.id = blockConfig.block.id
    }

    /**
     * Toolbox view
     */
    static get toolbox() {
      return {
        title: title,
        icon: icon,
      }
    }

    /**
     * Set state
     * @param {*} state
     */
    setState(state) {
      if (!isEqual(this.data, state)) {
        this.onChange()
        this.data = cloneDeep(state)
      }
    }

    /**
     * Allow any html in content
     */
    static get sanitize() {
      return true
    }

    /**
     * Save
     * @returns
     */
    save() {
      return this.data
    }

    /**
     * Render
     * @returns
     */
    render() {
      // Create holder element
      var div = document.createElement('div')

      const getComponent = () => (
        <Component
          initialState={cloneDeep(this.data)}
          handleStateChange={this.setState.bind(this)}
          {...this.config}
          id={this.id}
        />
      )

      createRoot(div).render(
        <EditExerciseBlock
          type={title}
          onPressEdit={() => this.config.openPanel(getComponent)}
          name={this.data?.name}
        />
      )

      return div
    }
  }
}
